var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproachLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 507,
    viewBox: "0 0 508 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_114",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 508,
    height: 507
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M508 0H0V507H508V0Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_114)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.154 506.786C394.118 506.786 507.582 393.322 507.582 253.358C507.582 113.394 394.118 -0.0700073 254.154 -0.0700073C114.19 -0.0700073 0.725952 113.394 0.725952 253.358C0.725952 393.322 114.19 506.786 254.154 506.786Z",
    fill: "url(#paint0_radial_103_114)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.151 429.676C351.01 429.676 429.529 350.525 429.529 252.888C429.529 155.251 351.01 76.1 254.151 76.1C157.292 76.1 78.7729 155.251 78.7729 252.888C78.7729 350.525 157.292 429.676 254.151 429.676Z",
    fill: "url(#paint1_radial_103_114)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.804 220.317L271.692 241.72C284.55 266.977 280.249 297.694 261.007 318.363C251.749 328.296 244.709 335.866 244.709 335.866C237.986 343.023 246.429 354.539 255.167 349.951L332.517 309.531C339.263 306.159 343.451 299.758 344.787 292.807C346.507 284.847 344.266 276.222 337.996 270.235L274.725 209.696C267.663 202.883 256.299 211.44 260.826 220.294L260.804 220.317Z",
    fill: "url(#paint2_linear_103_114)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.312 254.039L273.005 208.113C268.206 203.594 256.095 201.323 248.625 209.077C242.287 215.707 239.253 243.234 281.901 244.29C296.842 244.657 301.482 244.496 321.312 254.039Z",
    fill: "url(#paint3_linear_103_114)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.543 286.683L235.654 265.28C222.797 240.023 227.098 209.307 246.339 188.638C255.597 178.705 262.638 171.134 262.638 171.134C269.361 163.977 260.917 152.461 252.179 157.049L174.829 197.47C168.083 200.842 163.895 207.242 162.56 214.193C160.839 222.153 163.08 230.778 169.351 236.766L232.621 297.304C239.684 304.117 251.047 295.561 246.52 286.706L246.543 286.683Z",
    fill: "url(#paint4_linear_103_114)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.034 252.961L234.341 298.887C239.14 303.406 251.251 305.677 258.721 297.923C265.06 291.294 268.093 263.766 225.445 262.71C210.505 262.343 205.864 262.504 186.034 252.961Z",
    fill: "url(#paint5_linear_103_114)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_103_114",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.154 253.358) rotate(90) scale(253.428 253.428)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#F2F6FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEAFF",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_103_114",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.151 252.888) rotate(90) scale(176.788 175.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#F2F6FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEAFF",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_114",
    x1: 277.559,
    y1: 232.444,
    x2: 246.3,
    y2: 346.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71BDF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_114",
    x1: 292.441,
    y1: 262.516,
    x2: 253.291,
    y2: 219.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95D1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1298FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_103_114",
    x1: 199.243,
    y1: 281.6,
    x2: 225.631,
    y2: 156.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71BDF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_103_114",
    x1: 214.906,
    y1: 244.484,
    x2: 254.055,
    y2: 287.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95D1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1298FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproachLogo);
export default __webpack_public_path__ + "static/media/approach-logo.d00d07a95496caddc77408e4075c114e.svg";
export { ForwardRef as ReactComponent };